import { isNil } from '@flowio/is';
import createInlineCallbackListener from './create-inline-callback-listener';
export default function fiservThreedsIdentifyActionHandler(action, container) {
  if (isNil(container)) {
    // eslint-disable-next-line no-console
    console.error('fiservThreedsIdentifyActionHandler: Mounting container was not set.');
    return Promise.reject(new Error('fiservThreedsIdentifyActionHandler: Mounting container was not set.'));
  }

  var callbackPromise = createInlineCallbackListener({
    expiresAt: action.expires_at
  });
  var iframe = document.createElement('iframe');
  iframe.style.border = 'none';
  iframe.style.width = '1px';
  iframe.style.height = '1px';
  iframe.style.visibility = 'hidden';
  iframe.style.position = 'absolute'; // This mechanism is deliberate as it seems to be the only way to allow create a <form>
  // and <script> method and have them executed by the browser. The form and script are sent
  // to use as part of a string blob sent via Fiserv and we're not expected to altar.

  iframe.src = "data:text/html;charset=utf-8,".concat(encodeURI(action.threeds_identify_action.method));
  container.appendChild(iframe);
  return callbackPromise;
}
//# sourceMappingURL=fiserv-3ds-identify-action-handler.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@flowio/payment/lib/esm/utilities/fiserv-3ds-identify-action-handler.js
// module id = 601
// module chunks = 0 1